import { CheckOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'


function MarkReviewedButton({ itemID, userID, handleClick, isLoading }: {
  itemID: string;
  userID: string;
  isLoading: boolean;
  handleClick: (itemID: string, userID: string) => void
}) {
  return (
    <Tooltip title="Mark as Reviewed">
      <Button
        variant="outlined"
        onClick={() => handleClick(itemID, userID)}
        loading={isLoading}
        icon={<CheckOutlined size={12} />}
      />
    </Tooltip>
  )
}

export default MarkReviewedButton;
